import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { MyBetsEarlyPayoutService } from 'packages/sports/web/app/src/my-bets-base/early-payout/my-bets-earlypayout.service';
import { EarlyPayout, MyBetsBetSlip } from 'packages/sports/web/app/src/my-bets-base/models/my-bets-viewmodels';
import { BehaviorSubject, Observable } from 'rxjs';

export class EditBetEarlyPayoutSubscriptionService {
    private hasSubscription = false;
    private destoyed = false;

    private earlyPayout = new BehaviorSubject<Nullable<EarlyPayout>>(null);

    constructor(
        private betslip: MyBetsBetSlip,
        private earlyPayoutService: MyBetsEarlyPayoutService,
    ) {}

    get earlyPayout$(): Observable<Nullable<EarlyPayout>> {
        return this.earlyPayout.asObservable();
    }

    private pushEarlyPayout(value: Nullable<EarlyPayout>): void {
        this.earlyPayout.next(value);
    }

    async subscribe(): Promise<void> {
        if (this.hasSubscription) {
            return;
        }

        this.hasSubscription = true;

        await this.earlyPayoutService.mapEarlyPayoutAmount([this.betslip], (e) => this.pushEarlyPayout(e));
        this.pushEarlyPayout(this.betslip.earlyPayout || null);
    }

    unsubscribe(): void {
        if (!this.hasSubscription) {
            return;
        }
        this.hasSubscription = false;

        this.earlyPayoutService.dropEarlyPayoutSubscription();
    }

    get isSubscribed(): boolean {
        return this.hasSubscription;
    }

    destroy(): void {
        if (this.destoyed) {
            return;
        }

        this.destoyed = true;
        this.earlyPayout.complete();
    }
}
